import axios from 'axios';

const BankStatementService = {
  async createBankStatementTransaction({ formValues, id }) {
    const response = await axios.post(
      `/bank-statements/${id}/transactions`,
      formValues
    );

    return response.data;
  },
};

export default BankStatementService;
